import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "aggregation_avg",
  "use": "aggregation_avg-usage",
  "viewBox": "0 0 16 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 12\" id=\"aggregation_avg\"><path d=\"M15.75 4c0-.41-.34-.75-.75-.75H3.81l1.72-1.72c.29-.29.29-.77 0-1.06a.754.754 0 00-1.06 0L.19 4.75H15c.41 0 .75-.34.75-.75zM1 7.25c-.41 0-.75.34-.75.75s.34.75.75.75h11.19l-1.72 1.72c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l4.28-4.28H1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol